import React, {useState} from "react";
import { Container, Row, Col} from "react-bootstrap";
import "./PropertyComponent.scss";
import ImageCallBack from "../../modules/image-callback-module";
import { propertyDetailUrl, GetPrice, getAgentId } from "../../common/utils/property_utils";



const PropertyComponent = ({property_data}) => {

    const ImageRenderList = ({item, image_url, imagename, className}) => {
        let processedImages = JSON.stringify({});
        if (item?.imagetransforms?.images_Transforms) {
            processedImages = item?.imagetransforms?.images_Transforms;
        }
        return (
          <ImageCallBack 
            processedImages={processedImages} 
            imageSrc={image_url} 
            imagename={imagename} 
            strapi_id={item.id}
            altText={`${item.display_address}`}
            renderer="srcSet"
            classNames={className}
            ggfx_results={item?.ggfx_results}
        />                          
        )
    }

    var images_filter = property_data?.images?.length > 0 && property_data?.images?.filter(img => img?.url && img.url !== null)

    var property_url = propertyDetailUrl(property_data?.department, property_data?.search_type, property_data?.status, property_data?.slug, property_data?.id);

    return (
        <React.Fragment>
            <section className="property-component">
                <ImageRenderList item={property_data} image_url={images_filter[0]} imagename={"property.images.property_component"} className="property_img"  />
                <span className="transp_bg"></span>

                <div className="property_details">
                    <Container>

                        <h2>{property_data.display_address}</h2>
                        <div className="price">{GetPrice(property_data.price)} <span>{property_data.price_qualifier}</span></div>

                        <div className="icon_wrapper">
                            {property_data.property_type && 
                            <div className="icon-wrap property_type">
                                <span className="count">{property_data.property_type}</span>
                            </div>
                            }

                            {parseInt(property_data.bedroom) > 0 ?
                                <div className="icon-wrap">
                                    <i className="icon-bed"></i>
                                    <span className="count">{property_data.bedroom}</span>
                                </div>
                                :""
                            }

                            {parseInt(property_data.bathroom) > 0 ?
                                <div className="icon-wrap">
                                    <i className="icon-bath"></i>
                                    <span className="count">{property_data.bathroom}</span>
                                </div>
                                :""
                            }

                            {parseInt(property_data.reception) > 0 ?
                                <div className="icon-wrap">
                                    <i className="icon-reception"></i>
                                    <span className="count">{property_data.reception}</span>
                                </div>
                                :""
                            }
                        </div>
                        <a href={property_url} className="btn btn-primary">View Property Details</a>
                    </Container>
                </div>              
            </section>
        </React.Fragment>
    );
};
export default PropertyComponent;
